export default __webpack_public_path__ + "static/media/cp_geo_ws.17e330de.svg";